function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000000",
  d: "m28.828 169.172-4.242-4.243 4.242 4.243Zm19.657-19.657-4.242-4.243 4.242 4.243ZM34 68h84V56H34v12Zm90 6v60h12V74h-12Zm-96 72V74H16v72h12Zm-12 0v20.343h12V146H16Zm17.071 27.414 19.657-19.657-8.485-8.485-19.657 19.657 8.485 8.485ZM56.971 152H118v-12H56.97v12ZM16 166.343c0 8.909 10.771 13.371 17.071 7.071l-8.485-8.485c1.26-1.26 3.414-.368 3.414 1.414H16ZM124 134a6 6 0 0 1-6 6v12c9.941 0 18-8.059 18-18h-12Zm-6-66a6 6 0 0 1 6 6h12c0-9.941-8.059-18-18-18v12Zm-65.272 85.757A6 6 0 0 1 56.97 152v-12a17.999 17.999 0 0 0-12.728 5.272l8.485 8.485ZM34 56c-9.941 0-18 8.059-18 18h12a6 6 0 0 1 6-6V56Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#000000",
  d: "M74 28h84V16H74v12Zm90 6v60h12V34h-12ZM68 64V34H56v30h12Zm62 48h28v-12h-28v12Zm34-18a6 6 0 0 1-6 6v12c9.941 0 18-8.059 18-18h-12Zm-6-66a6 6 0 0 1 6 6h12c0-9.941-8.059-18-18-18v12ZM74 16c-9.941 0-18 8.059-18 18h12a6 6 0 0 1 6-6V16Z"
});

function SvgGchat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGchat);
export default __webpack_public_path__ + "static/media/gchat.f9c941e9.svg";
export { ForwardRef as ReactComponent };